"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const Farm_1 = __importDefault(require("@becrop/abstract/Models/Farm"));
const MapSideBarPanel_vue_1 = __importDefault(require("./MapSideBarPanel.vue"));
const SideBarFarmsListLoaderComponent_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/SideBarFarmsListLoaderComponent.vue"));
const ViewZero_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/ViewZero.vue"));
const lucide_vue_next_1 = require("lucide-vue-next");
const axios_1 = __importDefault(require("axios"));
const floating_vue_1 = require("floating-vue");
const Recommendation_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/Recommendation.vue"));
const RecommendationFieldComponent_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Recommendations/components/RecommendationFieldComponent.vue"));
const FarmSetupCTA_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/FarmSetupCTA.vue"));
const eBeCropIcon_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropIcon.vue"));
const eBeCropTag_vue_1 = __importDefault(require("@becrop/components/DashboardSingle/components/StatusTags/eBeCropTag.vue"));
let MapSideBarPanelFarms = class MapSideBarPanelFarms extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.searchParameter = '';
        this.farmsFilters = [];
        this.hasEnabledRecommendations = false;
        this.productSlugSelected = '';
        this.productSelected = null;
        this.isFetching = false;
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
    }
    updateProductSelected(product) {
        this.productSlugSelected = product.slug;
        this.productSelected = product;
    }
    openRecommendations(farm) {
        this.hasEnabledRecommendations = !this.hasEnabledRecommendations;
        if (farm.recommendations.length > 0) {
            this.updateProductSelected(farm.recommendations.sort((a, b) => b.level - a.level)[0]);
        }
    }
    get selectedFarm() {
        return this.currentFarm;
    }
    async downloadFarmPDF(farm) {
        await farm.downloadPDF();
    }
    get sortedProducts() {
        // Ordena los productos de mayor a menor según el 'level'
        return this.selectedFarm.recommendations.sort((a, b) => b.level - a.level);
    }
    mounted() {
        // this.$emit('fetchFarms');
    }
    get tableFarms() {
        return this.farmsFilters.length > 0 || this.searchParameter ? this.farmsFilters : this.farms;
    }
    setupNewFarm() {
        window.location.href = "/map_setup_activation";
    }
    selectFarm(farm) {
        this.$emit('selectFarm', farm);
    }
    onScroll(event) {
        const container = event.target;
        const nearBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;
        if (nearBottom && !this.isFetching) {
            this.isFetching = true; // Activamos la bandera
            this.$emit('fetchFarms');
            // Resetear la bandera después de completar la carga (simulación con timeout)
            setTimeout(() => {
                this.isFetching = false;
            }, 1000); // Ajusta el tiempo según sea necesario
        }
    }
    async onSearchChange(searchParameter) {
        this.searchParameter = searchParameter;
        this.farmsFilters = [];
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(async () => {
            if (searchParameter.length > 0) {
                this.farmsFilters = this.farms
                    .filter((farm) => farm.name.toUpperCase().trim().includes(searchParameter.toUpperCase().trim()))
                    .map((sam) => sam);
                await this.searchFarmBack(searchParameter);
            }
            else {
                this.searchParameter = null;
                this.farmsFilters = this.farms;
                this.selectFarm(this.farms[0]);
            }
        }, 1000);
    }
    async searchFarmBack(param) {
        const data = { search: param };
        await axios_1.default.post('/farms/api/list', data)
            .then(request => {
            const responseT = request;
            this.farmsFilters = [];
            responseT.data.data.forEach((farm) => {
                const farmModel = new Farm_1.default({
                    id: farm.id,
                    name: farm.name,
                    client_code: farm.client_code,
                    client_name: farm.client_name,
                    is_generative_zone: farm.is_generative_zone,
                    total_extension: farm.total_extension,
                    total_fields: farm.total_fields,
                    unit: farm.unit,
                    recommendations: farm.recommendations,
                    fields: farm.gis_fields,
                    generative_zones: farm.generative_zone.states,
                    fields_linked_to_projects: []
                });
                this.farmsFilters.push(farmModel);
            });
        })
            .catch(error => {
            console.error('Error en el POST:', error);
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], MapSideBarPanelFarms.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false })
], MapSideBarPanelFarms.prototype, "isLoadingFetchFarms", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new Farm_1.default({
            id: -1,
            name: '-',
            client_code: '-',
            client_name: '-',
            is_generative_zone: false,
            total_extension: -1,
            total_fields: -1,
            fields: [],
            unit: '-',
            recommendations: [],
            generative_zones: [],
            fields_linked_to_projects: []
        }) })
], MapSideBarPanelFarms.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], MapSideBarPanelFarms.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], MapSideBarPanelFarms.prototype, "isBiome", void 0);
MapSideBarPanelFarms = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Search: bmk_ui_framework_1.Search,
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            Tag: bmk_ui_framework_1.Tag,
            SideBarFarmsListLoader: SideBarFarmsListLoaderComponent_vue_1.default,
            LoaderInline: bmk_ui_framework_1.LoaderInline,
            ViewZero: ViewZero_vue_1.default,
            WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon,
            FilterIcon: bmk_ui_framework_1.FilterIcon,
            Button: bmk_ui_framework_1.Button,
            Plus: lucide_vue_next_1.Plus,
            Dropdown: floating_vue_1.Dropdown,
            Recommendation: Recommendation_vue_1.default,
            RecommendationFieldItem: RecommendationFieldComponent_vue_1.default,
            X: lucide_vue_next_1.X,
            ChevronDown: lucide_vue_next_1.ChevronDown, ChevronUp: lucide_vue_next_1.ChevronUp,
            FarmSetupCTA: FarmSetupCTA_vue_1.default,
            Separator: bmk_ui_framework_1.Separator,
            eBeCropIcon: eBeCropIcon_vue_1.default,
            eBeCropTag: eBeCropTag_vue_1.default,
            Loading: bmk_ui_framework_1.Loading,
            Download: lucide_vue_next_1.Download
        },
    })
], MapSideBarPanelFarms);
exports.default = MapSideBarPanelFarms;
